import * as z from "zod";
import { marketingAttributionSchema } from "./completeProfile";
import { mutator } from "./mutator";

// Named after the receiving HQ webhooks, which the Tines app posts to under
// these same three names as a booking progresses.
const demoRequestStages = ["submitted", "success", "cancel"] as const;
export type DemoRequestStage = (typeof demoRequestStages)[number];

export const recordDemoRequestSchema = z.object({
  stage: z.enum(demoRequestStages),
  marketingAttribution: marketingAttributionSchema.optional(),
});

// Writes nothing: the server mutator posts to the HQ lead pipeline after the
// transaction commits.
export const recordDemoRequest = mutator({
  stripKeys: {
    marketingAttribution: Object.keys(marketingAttributionSchema.shape),
  },
  schema: recordDemoRequestSchema,
  resolve: {},
  permissions: {
    none: "records the caller's progress through their own demo booking",
  },
  fn: async () => {},
});
